import { render, staticRenderFns } from "./ListsList.vue?vue&type=template&id=0d60c6f2&"
import script from "./ListsList.vue?vue&type=script&lang=js&"
export * from "./ListsList.vue?vue&type=script&lang=js&"
import style0 from "./ListsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports